import { render } from "./EventGrid.vue?vue&type=template&id=6ebea1ba&scoped=true"
import script from "./EventGrid.vue?vue&type=script&lang=js"
export * from "./EventGrid.vue?vue&type=script&lang=js"

import "./EventGrid.vue?vue&type=style&index=0&id=6ebea1ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebea1ba"]])

export default __exports__